import { NgRedux } from "@angular-redux/store";
import { Injectable } from "@angular/core";
import { GenericFormActions } from "../../../../shared/components/common-form/actions"

export interface TechProfilesListAction {
    type: string,
    payload: Object
}

@Injectable()
export class TechProfilesListActions {

    static GET_TECH_PROFILES_LIST = "GET_TECH_PROFILES_LIST";
    static GET_TECH_PROFILES_LIST_SUCCESS = "GET_TECH_PROFILES_LIST_SUCCESS";
    static GET_TECH_PROFILES_APPLIES_TO_LIST = "GET_TECH_PROFILES_APPLIES_TO_LIST";
    static GET_TECH_PROFILES_APPLIES_TO_LIST_SUCCESS = "GET_TECH_PROFILES_APPLIES_TO_LIST_SUCCESS";

    static TOGGLE_APPLIES_TO = "TOGGLE_APPLIES_TO";
    static CLEAR_APPLIES_TO = "CLEAR_APPLIES_TO";

    static SET_ATTACHMENTS_VISIBLE = "SET_ATTACHMENTS_VISIBLE";

    static DELETE_TECH_PROFILES = "DELETE_TECH_PROFILES";

    constructor(private ngRedux: NgRedux<Object>) { }

    getTechProfiles(clientId: string |number): void {
        this.ngRedux.dispatch({ type: TechProfilesListActions.GET_TECH_PROFILES_LIST, payload: clientId});
    }

    getAppliesToFilters(): void {
        this.ngRedux.dispatch({ type: TechProfilesListActions.GET_TECH_PROFILES_APPLIES_TO_LIST});
    }

    updateAppliesToState(option: any) {
        this.ngRedux.dispatch({type: TechProfilesListActions.TOGGLE_APPLIES_TO, payload: option});
    }

    sendDelete(payload) {
        this.ngRedux.dispatch({
            type: TechProfilesListActions.DELETE_TECH_PROFILES,
            payload,
        });
    }

    clearFilter() {
        this.ngRedux.dispatch({type: TechProfilesListActions.CLEAR_APPLIES_TO});
    }

    openAttachmentForm(techProfileId) {
        this.ngRedux.dispatch(
            {
                type: `commonForms::${GenericFormActions.FIELD_VALUE_UPDATED}`,
                payload: techProfileId,
                stateProp: `clientTechProfilesAttachments::${techProfileId}`,
                fieldProp: `id`,
            });
        this.ngRedux.dispatch({type: TechProfilesListActions.SET_ATTACHMENTS_VISIBLE, payload: techProfileId});

    }
}
